<template>
  <RevCard class="mx-auto grid max-w-[1200px] grid-cols-10 gap-24 p-24">
    <Stepper class="col-span-3" :steps="kybSteps" />
    <NuxtPage class="col-span-7" :kyb-data="kybData?.data" />
  </RevCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { RevCard } from '@ds/components/Card'

import { getKybResponseBuilder } from '~/api/kyb/kyb.mock'
import type { GetKybResponse } from '~/api/kyb/types'

import Stepper from './components/Stepper/Stepper.vue'

const kybData = ref<GetKybResponse | null>(getKybResponseBuilder())

const kybSteps = computed(() => kybData.value?.steps ?? [])

// TODO: Replace with actual API call
// const { data: kybData } = await useHttpFetch('/api/seller-experience/seller/kyb')
</script>
